import { useState, useCallback, useRef } from "react";

export const useAsync = <Args extends unknown[], ReturnType>(
  callback: (...args: Args) => Promise<ReturnType>
) => {
  const [hasBeenCalled, setHasBeenCalled] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | null>(null);
  const [data, setData] = useState<ReturnType | null>(null);
  const lastCalledArgs = useRef<Args | null>(null);

  const execute = useCallback((...args: Args) => {
    setLoading(true);
    setHasBeenCalled(true);
    setError(null);
    setData(null);
    lastCalledArgs.current = args;

    return callback(...args)
      .then((result) => {
        setData(result);
        return result;
      })
      .catch((err) => {
        setError(err);
        throw err;
      })
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return [
    execute,
    { loading, error, data, hasBeenCalled, lastCalledArgs: lastCalledArgs.current ?? null },
  ] as const;
};
